import { useQuery } from "@tanstack/react-query"
import { shopifySearchProductsQuery } from "modules/settings/lib/shopify/shopifySearchProductsQuery"

type Props = {
  enabled?: boolean
  includeDraft?: boolean
  query: string
}

export function useShopifySearchProductsQuery({ enabled = true, includeDraft, query }: Props) {
  const normalizedQuery = query.trim().replace(/\s+/g, " ")

  return useQuery({
    ...shopifySearchProductsQuery({ includeDraft, query: normalizedQuery }),
    enabled,
  })
}
